export default {
    "general.knowYourLoan.header": "conozca su préstamo. ama a tu prestamista.",
    "general.knowYourLoan.paragraph": "desde la propiedad de la vivienda hasta la innovación de la vivienda, impulsamos los préstamos modernos con soluciones financieras rápidas y tecnológicas."  
}